import React from "react";
import useTakeScreenShot from "../../../../hooks/core/useTakeScreenShot";
import ScreenShot from "../atom/ScreenShot";


const AddHistoryImages = ({ screenShot, screenShotReady, summaryImageElement }) => {

  return (
    <div className={"detail-design-history-images"}>
      <ScreenShot image={screenShot[0]?.img}
                  screenShotReady={screenShotReady}
                  summaryImageElement={summaryImageElement}
      />
      <ScreenShot image={screenShot[2]?.img}
                  screenShotReady={screenShotReady}
                  summaryImageElement={summaryImageElement}
      />
    </div>
  )

}

export default AddHistoryImages;
